import _asyncToGenerator from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.split.js";
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

// 자동세팅
var loc = JSON.parse(JSON.stringify(window.location));
var firstname = loc.hostname.substr(0, 7) === '192.168' ? loc.hostname : loc.hostname.indexOf('test.') > -1 ? 'api.' + loc.hostname.split('.').slice(-3).join('.').replace('http://', '').replace('https://', '') : loc.hostname.split('.').length > 1 ? 'api.' + loc.hostname.split('.').slice(-2).join('.').replace('http://', '').replace('https://', '') : loc.hostname;
Vue.prototype.$siteURL = loc.protocol + '//' + loc.hostname;
Vue.prototype.$hostURL = loc.protocol + '//' + loc.hostname + ':8080';
Vue.prototype.$apiURL = Vue.prototype.$hostURL + '/v1';

// 강제세팅
Vue.prototype.$hostURL = 'https://api.seongsudonggorilla.com:8080'; // ELB 적용으로 강제 세팅
// Vue.prototype.$apiURL = 'http://api.test.bluffcatch.com:8080/v1'
Vue.prototype.$apiURL = 'https://api.seongsudonggorilla.com:8080/v1';
Vue.axios.defaults.baseURL = Vue.prototype.$apiURL;
export default (/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Vue = _ref.Vue;
          Vue.prototype.$axios = axios;
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());